import axios from 'axios'

const initializeAxios = () => {
    axios.defaults.baseURL = 'https://api.arjanhesab.ir/'
    // axios.defaults.baseURL = 'http://127.0.0.1:8000/'
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access')
    axios.defaults.withCredentials = true
    axios.interceptors.request.use(config => {
        if (config.url === "users/login/" | config.url === "users/refresh/") {
            config.headers = {}
        }
        return config
    })
    axios.interceptors.response.use(response => {
        return response
    }, error => {
        return new Promise((resolve, reject) => {
            const originalRequest = error.config
            if (error.response.status === 401 && error.config && !error.config.__isRetryRequest &&
                error.config.url !== 'users/refresh/' && error.config.url !== 'users/login/') {
                originalRequest.__retry = true
                let result = fetch('https://api.arjanhesab.ir/users/refresh/', {
                    // let result = fetch('http://127.0.0.1:8000/users/refresh/', {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'include',
                    redirect: 'follow',
                    referrer: 'no-referrer',
                }).then(result => result.json()).then(result => {
                    console.log(result);
                    localStorage.setItem('access', result.access)
                    originalRequest.headers['Authorization'] = 'Bearer ' + result.access
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + result.access
                    return axios(originalRequest)
                })
                resolve(result)
            }
            return Promise.reject(error)
        })
    })
}

export default initializeAxios